import React, { useState, useEffect } from 'react';
import '../css/Footer.css';
import { ReactComponent as Logo } from '../assets/paulo-bastos-logo-extended-horizontal.svg';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  
  return (
    <footer className="footer">

        <div className="footer-logo">
                <NavLink to="/">
                  <Logo />
                </NavLink>
        </div>
          
        <div className="footer-text">
          <p>© 2025 Paulo Bastos. All rights reserved.</p>
        </div>

    </footer>
  );
};

export default Footer;
